import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitobhopalcab() {



  const cardData = {
    keyword: " Mumbai to Bhopal Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Bhopal cab service, providing safe, comfortable, and affordable long-distance travel for families, corporate travelers, students, and group journeys. The Mumbai to Bhopal route connects Maharashtra with Madhya Pradesh and covers approximately 770 to 800 km via well-maintained national highways, making it a smooth interstate road trip. Our professional drivers ensure a safe, punctual, and stress-free journey with proper breaks, highway comfort stops, and door-to-door pickup and drop service. We offer flexible options including one-way drops, round trips, and customized travel itineraries. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Bhopal cab service.",

"topPlaces": [
  {
    "title": "Upper Lake (Bhojtal)",
    "description": "Upper Lake, also known as Bhojtal, is one of the largest artificial lakes in Asia and a major attraction in Bhopal. It offers boating, sunset views, and peaceful waterfront areas, making it a perfect relaxation spot after a long road journey from Mumbai. The lake is surrounded by greenery and is a key leisure destination for tourists visiting the city."
  },
  {
    "title": "Van Vihar National Park",
    "description": "Van Vihar National Park is a protected wildlife sanctuary located near Upper Lake, home to tigers, leopards, deer, and various bird species. It offers safari-style viewing and nature walks, making it a popular attraction for families and nature lovers traveling to Bhopal by cab."
  },
  {
    "title": "Taj-ul-Masajid",
    "description": "Taj-ul-Masajid is one of the largest mosques in India and an iconic landmark of Bhopal known for its grand Mughal architecture and spiritual significance. The mosque attracts visitors for its massive structure, peaceful ambiance, and historical importance in the cultural heritage of the city."
  },
  {
    "title": "Bhimbetka Rock Shelters",
    "description": "Bhimbetka Rock Shelters, a UNESCO World Heritage Site located near Bhopal, showcase prehistoric cave paintings dating back thousands of years. It is a major archaeological site offering insights into early human life and is a must-visit destination for history enthusiasts traveling from Mumbai."
  },
  {
    "title": "Sanchi Stupa",
    "description": "Sanchi Stupa is a world-famous Buddhist monument built by Emperor Ashoka and located near Bhopal. It is known for its beautifully carved gateways, ancient stupas, and spiritual significance, attracting tourists and pilgrims from across India and abroad."
  },
  {
    "title": "Shaukat Mahal",
    "description": "Shaukat Mahal is a unique architectural structure in Bhopal that blends Gothic and Islamic styles. Located in the old city, it stands as a symbol of the city’s royal heritage and historical diversity, making it a popular sightseeing stop."
  },
  {
    "title": "New Market Bhopal",
    "description": "New Market is one of the busiest shopping areas in Bhopal offering clothing, accessories, street food, and local goods. It is a vibrant commercial hub where travelers can experience the local lifestyle and shopping culture of the city."
  },
  {
    "title": "Birla Mandir (Lakshmi Narayan Temple)",
    "description": "Birla Mandir in Bhopal is a peaceful hilltop temple dedicated to Lord Vishnu and Goddess Lakshmi. It offers panoramic views of the city along with a serene spiritual atmosphere, making it a popular stop for pilgrims and tourists."
  },
  {
    "title": "Indira Gandhi Rashtriya Manav Sangrahalaya",
    "description": "This open-air museum showcases India’s tribal culture, traditional houses, and heritage exhibits. It provides a deep cultural experience for visitors and is one of Bhopal’s most educational and unique attractions."
  },
  {
    "title": "Bharat Bhavan",
    "description": "Bharat Bhavan is a multi-arts complex in Bhopal that promotes visual arts, theatre, music, and literature. It is a cultural landmark that attracts artists, students, and tourists interested in India’s creative heritage."
  }
],






services: [
  {
    name: "Mumbai to Bhopal Cab",
    description: "Mumbai to Bhopal cab service offers a comfortable and reliable long-distance journey connecting Maharashtra to Madhya Pradesh. Ideal for families, business travelers, and tourists, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles provide comfort throughout the journey. It guarantees a safe and hassle-free experience."
  },
  {
    name: "Mumbai to Bhopal Taxi",
    description: "Mumbai to Bhopal taxi provides private and convenient intercity travel with flexible schedules. This service includes door-to-door pickup and comfortable seating for long-distance travel. Professional drivers ensure safe journeys. It guarantees a smooth ride."
  },
  {
    name: "Mumbai to Bhopal Cab Service",
    description: "Mumbai to Bhopal cab service offers professional travel solutions with multiple vehicle options. This service is ideal for business trips, family travel, and long-distance journeys. Clean vehicles and trained drivers enhance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Mumbai to Bhopal Taxi Service",
    description: "Mumbai to Bhopal taxi service ensures dependable transportation with comfortable vehicles and experienced chauffeurs. This service is suitable for long-distance travel. Flexible booking options make travel convenient. It guarantees a pleasant journey."
  },
  {
    name: "Cab from Mumbai to Bhopal",
    description: "Cab from Mumbai to Bhopal offers a convenient way to travel between cities with complete comfort. This service is ideal for those preferring road trips over flights. Professional drivers ensure safe travel. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Bhopal",
    description: "Taxi from Mumbai to Bhopal provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with professional drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Bhopal Cab Booking",
    description: "Mumbai to Bhopal cab booking allows customers to reserve their ride easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Bhopal Taxi Booking Online",
    description: "Mumbai to Bhopal taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Bhopal Cab Price",
    description: "Mumbai to Bhopal cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Bhopal Taxi Fare",
    description: "Mumbai to Bhopal taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Bhopal One Way Cab",
    description: "Mumbai to Bhopal one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Bhopal Round Trip Taxi",
    description: "Mumbai to Bhopal round trip taxi provides complete travel solutions including return journeys. This service is ideal for business trips and vacations. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Bhopal Innova Cab",
    description: "Mumbai to Bhopal Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable intercity experience."
  },
  {
    name: "Mumbai to Bhopal Ertiga Cab",
    description: "Mumbai to Bhopal Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Bhopal Sedan Cab",
    description: "Mumbai to Bhopal sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Bhopal SUV Taxi",
    description: "Mumbai to Bhopal SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Bhopal Cab",
    description: "Cheap Mumbai to Bhopal cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mumbai to Bhopal Taxi Service",
    description: "Best Mumbai to Bhopal taxi service ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mumbai to Bhopal Cab", "Mumbai to Bhopal Taxi"],
  ["Mumbai to Bhopal Cab Service", "Mumbai to Bhopal Taxi Service"],
  ["Cab from Mumbai to Bhopal", "Taxi from Mumbai to Bhopal"],
  ["Mumbai to Bhopal Cab Booking", "Mumbai to Bhopal Taxi Booking Online"],
  ["Mumbai to Bhopal Cab Price", "Mumbai to Bhopal Taxi Fare"],
  ["Mumbai to Bhopal One Way Cab", "Mumbai to Bhopal Round Trip Taxi"],
  ["Mumbai to Bhopal Innova Cab", "Mumbai to Bhopal Ertiga Cab"],
  ["Mumbai to Bhopal Sedan Cab", "Mumbai to Bhopal SUV Taxi"],
  ["Cheap Mumbai to Bhopal Cab", "Best Mumbai to Bhopal Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Bhopal Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Bhopal cab service, ideal for long-distance business trips and family travel."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate travel, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Ideal for Business & Family Trips",
    WhyChoosedescription: "Whether for corporate travel or family visits, our Mumbai to Bhopal cab service ensures a relaxed and hassle-free journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Bhopal trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Bhopal cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Bhopal cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Bhopal cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Bhopal for one-way and round trips." },
  { question: "What is the distance between Mumbai and Bhopal?", answer: "The distance is approximately 750 to 800 km and takes around 13 to 16 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Bhopal cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for family travel?", answer: "Yes, our service is ideal for both family and business travel." },
  { question: "Do you provide interstate travel permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Kulkarni",
    feedback: "The Mumbai to Bhopal cab service with Royal Route Cabs was very comfortable and well-managed. The long journey felt safe and smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Deshmukh",
    feedback: "Excellent experience traveling from Mumbai to Bhopal. The cab was clean, the driver was professional, and the entire trip was hassle-free and relaxing.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhopal Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-bhopal-cab.jpg", // replace if needed
  "description": "Book Mumbai to Bhopal cab service with Royal Route Cabs for safe, reliable, and comfortable long-distance travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 intercity taxi service at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "16", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-bhopal-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Bhopal Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Bhopal cab with Royal Route Cabs. Safe and affordable long-distance taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable intercity travel."
  />

  <meta
    name="keywords"
    content="mumbai to bhopal cab, mumbai to bhopal taxi, mumbai to bhopal cab service, mumbai to bhopal taxi service, cab from mumbai to bhopal, taxi from mumbai to bhopal, mumbai to bhopal cab booking, mumbai to bhopal taxi booking online, mumbai to bhopal cab price, mumbai to bhopal taxi fare, mumbai to bhopal one way cab, mumbai to bhopal round trip taxi, mumbai to bhopal innova cab, mumbai to bhopal ertiga cab, mumbai to bhopal sedan cab, mumbai to bhopal suv taxi, cheap mumbai to bhopal cab, best mumbai to bhopal taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhopalcab;